if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      const [day, month, year] = this.dataset.date.split('-').map(Number);
      const [tarhour = 0, tarmin = 0] = (this.dataset.time || '').split(':').map(Number);
      const timezone = this.dataset.timezone;
      const dateString = `${month}/${day}/${year} ${tarhour}:${tarmin} GMT${timezone}`;
      this.countDownDate = new Date(dateString).getTime();
    }

    connectedCallback() {
      const daysEl = this.querySelector('.days .countdown-timer--column--number');
      const hoursEl = this.querySelector('.hours .countdown-timer--column--number');
      const minutesEl = this.querySelector('.minutes .countdown-timer--column--number');
      const secondsEl = this.querySelector('.seconds .countdown-timer--column--number');

      const updateTime = () => {
        const now = Date.now();
        const distance = this.countDownDate - now;

        if (distance < 0) {
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = CountdownTimer.addZero(days);
        hoursEl.textContent = CountdownTimer.addZero(hours);
        minutesEl.textContent = CountdownTimer.addZero(minutes);
        secondsEl.textContent = CountdownTimer.addZero(seconds);

        requestAnimationFrame(updateTime);
      };

      requestAnimationFrame(updateTime);
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? "0" + x : x;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
